(function () {
    'use strict';

    angular.module("EventListApp").controller('EventCtrl', eventCtrl)
    eventCtrl.$inject = ['$scope', 'ApiFactory', 'Constants', 'SpinnerService', '$timeout', 'SectionRegistry'];

    function eventCtrl($scope, ApiFactory, Constants, SpinnerService, $timeout, SectionRegistry) {
        const vm = this;
        //#region properties
        vm.pageUrl = PageUrl;
        vm.form = { mailto: "", name: "", message: "" }
        vm.mailtoOrganizer = true;
        vm.mailSuccess = false;
        vm.result = "";
        vm.date = new Date().getDate();
        vm.EventID = 0;
        vm.lang = 9;
        vm.submitted = false;
        let scrollInProgress = false;
        //sections for api call / render content
        const EventListSections = Constants.EventListSections;
        let currentPageID = 0;
        vm.allowScroll = true; // todo - lock scroll if needed
        // todo: translate text
        let msg = Constants.Texts.ShareLinkTxt + vm.pageUrl;
        // this is a list of sections as jquery html elements
        vm.allSections = [];
        vm.CityInfo = {};
        //this needs to be in eventlist agenda directive to track changes if multiple agenda sections in same page
        vm.showProgram = false;
        let currentAgenda = 0;
        let webID = 0;
        let userCountry = 0;
        const bsOffcanvas = new bootstrap.Offcanvas('#ws-sidebar')
        const utmParams = ['utm_source', 'utm_medium', 'utm_campaign'];

        let isEmbed = false;
        const sectionTemplate = { id: "", top: 0, height: 0, bottom: 0, order: 0, loadedContent: false, loadingApiData: true };

        const captchaSuccess = function (response) {
            vm.MailModel.Captcha = response;
        };

        window.captchaSuccess = captchaSuccess;

        vm.isActiveTab = function (idx) {
            return currentAgenda == idx;
        }

        vm.setActiveTab = function (idx) {
            currentAgenda = idx;
        }

        vm.repeatEnd = function () {
            $timeout(function () {
                sendDocHeightMsg();
            }, 1200)
        }

        vm.MailModel = {
            Code: "", FirstName: "",
            MessageFrom: "", MessageTo: "",
            Subject: "", MessageBody: "", Lang: vm.lang
        }

        if (IsLocal) {
            const arr = vm.pageUrl.split(window.location.host);
            vm.pageUrl = "https://events.eventact.com/" + arr[1]
        }

        // page url as a query string value for the share links
        vm.pageUrlEncoded = encodeURIComponent(vm.pageUrl);

        //#endregion properties


        // this is for sitebrain when embedding section 
        function sendDocHeightMsg(event) {
            //post message if needed
            if (parent.postMessage) {
                // actual page content
                const height = document.getElementById('wrapper').offsetHeight;
                parent.postMessage({ height: height, source: "website" }, '*');
            }
        }

        // assign onload handler 
        // send docHeight onload
        window.addEventListener('load', sendDocHeightMsg, false);

        //#region scope function
        vm.sliderInit = function () {
            $("#slider").backgroundCycle({
                fadeSpeed: 2000,
                duration: 6000,
                backgroundSize: scalingMode.COVER
            });

            setsliderWelcomeHeight();
        }

        // todo: get properties from cookie, set properties for specific section in section ng-init
        vm.init = function (pageID, eventID, code, date, lang, tz, embed, eventSecret, wsMode) {
            // for openAPI
            ApiFactory.SetToken(eventSecret);
            if (wsMode) // if setup mode
                ApiFactory.setCacheMode(wsMode);

            initProperties(pageID, eventID, code, date, lang, tz);
            loadUserCountry();
            isEmbed = embed;
            setClientCookie();

            if (typeof getWebID == 'function')
                webID = getWebID();
            // init site logs (sitebrain)
            if (typeof Ea_eventact == 'function')
                Ea_eventact(eventID, false, '', lang, webID, 6);

            vm.allSections = setSections();

            // if link to specific section: finish main thread and wait for html/angular to render and scroll to section
            // also block user scroll to prevent issues
            if (window.location.hash) {
                vm.allowScroll = false;
                $timeout(scrollToSection, 1000);
            }

            if (vm.allowScroll)
                loadIfNeeded();

            bindMenuClick();

            // add UTM params exists for website: add to all registration links
            const links = document.querySelectorAll('a[href^="https://"]');
            links.forEach(function (link) {
                if (isReglink(link.href)) {
                    link.href = addAdditionalParams(link.href, utmParams);
                }
            });

            // html rendered
            $scope.$on('$viewContentLoaded', function () {
                loadIfNeeded();
            });


        };

        // todo: better to do after api call for preformence
        vm.showSpeakerCountry = function (countryDisplay, speakerCountry) {
            if (!speakerCountry)
                return false;

            switch (countryDisplay) {
                case 0:
                    return true;
                case 1:
                    return false;
                case 2:
                    return speakerCountry != userCountry;
            }
        }

        vm.addParamsToLink = function (elemID) {
            const element = document.getElementById(elemID);
            if (!element) return;
            const href = element.getAttribute('ng-href') || element.getAttribute('href');
            if (href)
                element.href = addAdditionalParams(href, utmParams);
        }

        vm.getColor = function (bg) {
            const el = document.getElementById(bg);
            if (!el)
                return;

            if (isBGColorlight(el))
                return "btn-dark"

            return "btn-light";
        }

        vm.shareByMail = function () {
            vm.mailtoOrganizer = false;
            grecaptcha.reset();
            setModalVal(msg);
        };

        vm.sendMail = function () {
            vm.submitted = true;
            //if share by mail and captcha not valid return false
            if ($scope.contactForm.$invalid || (!vm.MailModel.Captcha && !vm.mailtoOrganizer))
                return false;

            const name = vm.form.name;
            vm.MailModel.FirstName = name;
            vm.MailModel.Lang = vm.lang;

            if (vm.mailtoOrganizer) {
                vm.MailModel.Subject = Constants.Texts.EmailSubject + name;
                vm.MailModel.MessageFrom = vm.form.mailto;
            }
            else {
                vm.MailModel.MessageFrom = Constants.Texts.NoReply;
                vm.MailModel.MessageTo = vm.form.mailto;
                vm.MailModel.Subject = Constants.Texts.EmailSubject + name;
            }

            vm.MailModel.MessageBody = vm.form.message;
            let firstName = name; // For Success/Failure Message
            if (firstName.indexOf(' ') >= 0)
                firstName = name.split(' ').slice(0, -1).join(' ');

            vm.MailModel.MailToOrganizer = vm.mailtoOrganizer;
            vm.mailSuccess = false;

            ApiFactory.SendMail(vm.MailModel).then(function (response) {
                if (response.data.success) {
                    vm.result = "Your message has been sent.";
                    vm.mailSuccess = true;
                }
                else {
                    if (response.data.errorMsg)
                        vm.result = response.data.errorMsg;
                    else
                        vm.result = "Sorry " + firstName + ", mail delivery failed , check input and try again!";
                }
            }).catch(function (response) {
                vm.mailSuccess = false;
                vm.result = "Sorry " + firstName + ", it seems that my mail server is not responding. Please try again later!";
                //clear all fields
                resetForm();
            })
        };

        function resetForm() {
            $scope.contactForm.$setPristine();
            $scope.contactForm.$setUntouched();
            vm.submitted = false;
            vm.form = {};
            vm.mailSuccess = false;
        }

        vm.showSpeaker = function (speaker) {
            vm.currUser = speaker;
            vm.currExhibitor = null;

            $timeout(function () {
                let dir = isRTL(vm.currUser.aboutMe || '') ? 'rtl' : 'ltr';
                document.querySelectorAll('#speakersModal .speaker-bio p').forEach(function (el) { el.classList.add(dir); });

                dir = isRTL(vm.currUser.organization || '') ? 'rtl' : 'ltr';
                document.querySelectorAll('#speakersModal .speaker-details').forEach(function (el) { el.classList.add(dir); });

                //speaker-bio
                bootstrap.Modal.getOrCreateInstance(document.getElementById('speakersModal')).show();
                bootstrap.Modal.getOrCreateInstance(document.getElementById('exhibitorModal')).hide();
            }, 0)

        };

        vm.showExhibitorModal = function (exhibitor) {
            vm.currUser = null;
            bootstrap.Modal.getOrCreateInstance(document.getElementById('speakersModal')).hide();
            vm.currExhibitor = exhibitor;
            const yPosition = event.pageY;
            $timeout(function () {
                if (isRTL(exhibitor.aboutMe))
                    document.querySelectorAll('.exhibitor-bio p').forEach(function (el) { el.style.direction = 'rtl'; });

                const exhibitorModal = document.getElementById('exhibitorModal');
                exhibitorModal.dataset.y = yPosition;
                bootstrap.Modal.getOrCreateInstance(exhibitorModal).show();
            }, 0)
        }

        vm.showLoading = function (mySpinner) {
            const foundSection = vm.allSections.filter(function (sec) {
                return sec.id === mySpinner
            })[0];
            if (foundSection != undefined && foundSection.loadedContent == false)
                SpinnerService.Show(mySpinner);
        };

        vm.isEmpty = function (obj) {
            for (let key in obj) {
                if (obj.hasOwnProperty(key))
                    return false;
            }
            return true;
        };

        vm.exhibitorClass = function (exhibitor, length, index, hasSideImage) {
            if (exhibitor.cssClass)
                return exhibitor.cssClass;

            if (length == 0 || length == undefined)
                return '';

            exhibitor.cssClass = getExhibitorClass(length, index, hasSideImage);
            return exhibitor.cssClass;
        };

        vm.loadMoreIfNeeded = function () {
            loadIfNeeded();
        }

        vm.hasError = function (field, validation) {
            if ($scope.contactForm[field] == undefined)
                return;

            if (validation)
                return ($scope.contactForm[field].$touched && $scope.contactForm[field].$error[validation]) || (vm.submitted && $scope.contactForm[field].$error[validation]);

            return ($scope.contactForm[field].$touched && $scope.contactForm[field].$invalid) || (vm.submitted && $scope.contactForm[field].$invalid);
        };

        vm.getStyle = function (bgImage, bgColor, fontColor, fixedBG) {
            if (!bgColor && !bgImage && !fontColor)
                return "";

            if (IsLocal && bgImage && bgImage.indexOf('http'))
                bgImage = "https://images.eventact.com" + bgImage;

            const style = {};
            if (fontColor)
                style["color"] = fontColor;// += 'color:' + fontColor + ";"
            if (bgColor)
                style["background-color"] = bgColor;// += 'background-color:' + bgColor + ";"
            else if (bgImage) {
                style['background-image'] = 'url(' + bgImage + ')';
                style['background-size'] = "cover";
                style['background-position-y'] = 'center';
                style['background-position-x'] = 'center';
                if (fixedBG) {
                    style['background-attachment'] = "fixed";
                    style['min-height'] = "40vh";
                }
            }
            return style;
        }



        //#endregion  scope function

        //#region functions

        function loadIfNeeded() {
            if (scrollInProgress)
                return;

            if (vm.allSections.length > 0)
                vm.allSections.forEach(function (section) {
                    if (!section.loadedContent && sectionIsVisiable(section))
                        loadSection(section);
                });
        }

        function getExhibitorClass(length, index, hasSideImage) {
            if (length == 0 || length == undefined)
                return '';

            return getClass(length, index, hasSideImage);
        }

        function getClass(length, index, hasSideImage) {
            let cssClass = 'pt-3 ';
            switch (length) {
                //case 1: cssClass += 'col-sm-6 offset-sm-3';
                //    break;
                //case 2: cssClass += 'col-sm-6';
                //    break;
                //case 3: cssClass += 'col-sm-6 col-md-4';
                //    break;
                default:
                    if (hasSideImage)
                        cssClass += 'col-sm-12 col-md-6';
                    else
                        cssClass += 'col-sm-6 col-md-3';
                    break;
            }

            return cssClass;
        };

        function setModalVal(msg) {
            resetForm();
            vm.result = "";
            if (msg)
                vm.form.message = msg;

            vm.mailSuccess = false;
            bootstrap.Modal.getOrCreateInstance(document.getElementById('mailModal')).show();
        }

        function sectionIsVisiable(section, fullyInView) {
            const s = document.getElementById(section.id);
            if (!s) return false;
            const onlyIfFullyInView = fullyInView || false;

            const pageTop = window.scrollY;
            const pageBottom = pageTop + window.innerHeight;
            const rect = s.getBoundingClientRect();
            const elementTop = rect.top + window.scrollY;
            const elementBottom = elementTop + rect.height;

            if (onlyIfFullyInView === true)
                return ((pageTop < elementTop) && (pageBottom > elementBottom));
            else
                return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
        }

        function bindMenuClick() {
            document.querySelectorAll('a[href*="#"]:not([href="#"])').forEach(function (anchor) {
                anchor.addEventListener('click', function (event) {
                    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') || location.hostname == this.hostname) {
                        const target = document.querySelector(this.hash) || document.querySelector('[name=' + this.hash.slice(1) + ']');
                        if (target) {
                            scrollInProgress = true;
                            //get section object
                            const section = vm.allSections.find(function (s) {
                                return s.id == target.id;
                            })

                            if (section)
                                loadSection(section);

                            // jQuery animation, as in the old code - the native behavior:'smooth' can be
                            // skipped by the browser (OS animations off) and is cut by the menu closing
                            $('html, body').animate({ scrollTop: target.getBoundingClientRect().top + window.scrollY }, 500)
                                .promise().then(function () {
                                    scrollInProgress = false;
                                    closeMenu();
                                });
                            event.preventDefault();
                        }
                    }
                });
            });
        }

        vm.imgError = function (obj) {
            obj.style.display = 'none';
            if (obj.nextElementSibling)
                obj.nextElementSibling.classList.remove('hg-hide');
        }


        function setSections() {
            const list = [];
            let i = 0;
            document.querySelectorAll('section').forEach(function (value) {
                const newSection = angular.copy(sectionTemplate);
                newSection.loadSection = value.getAttribute("loadsection");
                if (newSection.loadSection != null) {
                    newSection.id = value.id;
                    newSection.order = i++;
                    newSection.loadedContent = false;
                    newSection.loadingApiData = false;
                    if (i > 3) {
                        const body = document.querySelector('#' + value.id + ' .section-body');
                        if (body) body.style.display = 'none';
                    }

                    list.push(newSection);
                }
            });
            return list;
        }

        function loadSection(section) {
            // if section is not loaded or loading => load it.
            if (section.loadedContent || section.loadingApiData || vm.EventID == undefined)
                return false;

            section.loadingApiData = true;
            switch (section.loadSection) {
                case EventListSections.Registration:
                    // the section loads its own data - see Directives/SectionRegistration.js
                    SectionRegistry.load(section.id, vm.EventID, vm.lang)
                        .then(function (hasData) {
                            if (hasData) {
                                handleReceivedData(section.id);
                                showContent(section);
                            }
                        }).catch(function (response) {
                            console.log("response: " + (response && response.data));
                        })
                    break;

                case EventListSections.News:
                    // the section loads its own data - see Directives/SectionNews.js
                    SectionRegistry.load(section.id, vm.EventID, vm.lang).then(function (hasData) {
                        if (hasData)
                            handleReceivedData(section.id);

                        showContent(section);
                    }).catch(function (response) {
                        console.log("response: " + response);
                    })
                    break;

                case EventListSections.SpeakersAll:
                case EventListSections.Speakers:
                case EventListSections.SpeakersKeynote:
                case EventListSections.SpeakersFeatured:
                case EventListSections.Organizers:
                case EventListSections.Committee:
                    // the section loads its own data - see Directives/SectionSpeakers.js
                    SectionRegistry.load(section.id, vm.EventID, vm.lang).then(function (hasData) {
                        if (hasData)
                            handleReceivedData(section.id);

                        showContent(section);
                    }).catch(function (response) {
                        console.log("response: " + response);
                    }).finally(function () {
                        if (section.loadSection == EventListSections.SpeakersKeynote || section.loadSection == EventListSections.SpeakersFeatured)
                            section.loadedContent = true;
                    });
                    break;

                case EventListSections.Exhibitors:
                case EventListSections.Sponsors:
                case EventListSections.ParticipatingCompanies:
                case EventListSections.AllExhibitors:
                    // the section loads its own data (offline: from the local storage)
                    // see Directives/SectionExhibitors.js and Directives/SectionAllExhibitors.js
                    SectionRegistry.load(section.id, vm.EventID, vm.lang).then(function (hasData) {
                        if (hasData)
                            handleReceivedData(section.id);

                        showContent(section);
                    }).catch(function (response) {
                        console.log("response: " + response);
                    })
                    break;

                case EventListSections.SliderGallery:
                    // the section loads its own data - see Directives/SectionSliderGallery.js
                    SectionRegistry.load(section.id, vm.EventID, vm.lang).then(function (hasData) {
                        if (hasData)
                            handleReceivedData(section.id);

                        showContent(section);
                    }).catch(function (response) {
                        console.log("response: " + response);
                    })
                    break;

                case EventListSections.Topics:
                    // the section loads its own data - see Directives/SectionTopics.js
                    SectionRegistry.load(section.id, vm.EventID, vm.lang).then(function (hasData) {
                        if (hasData)
                            handleReceivedData(section.id);

                        showContent(section);
                    }).catch(function (response) {
                        console.log("response: " + response);
                    })
                    break;

                case EventListSections.ContactUs:
                    // the section loads its own links - see Directives/SectionContactUs.js
                    SectionRegistry.load(section.id, vm.EventID, vm.lang, { pageId: currentPageID }).then(function () {
                        handleReceivedData(section.id);
                        showContent(section);
                    }).catch(function (response) {
                        console.log("Gallery Images error: " + (response && response.data));
                    })
                    // no break: falls through to Program (existing behavior, kept on purpose)

                case EventListSections.Program:
                    vm.showProgram = true;
                    showContent(section);
                    handleReceivedData(section.id);
                    break;

                case EventListSections.TimeTable:
                    vm.showTimeTable = true;
                    handleReceivedData(section.id);
                    showContent(section);
                    break;

                case EventListSections.Video:
                    // the section shows its own hall player - see Directives/SectionVideo.js
                    SectionRegistry.load(section.id, vm.EventID, vm.lang);
                    handleReceivedData(section.id);
                    showContent(section);
                    break;

                case EventListSections.Counter:
                    // the section sets its own count down - see Directives/SectionCounter.js
                    SectionRegistry.load(section.id, vm.EventID, vm.lang, { date: vm.date, offset: vm.offset });
                    handleReceivedData(section.id);
                    showContent(section);
                    break;

                case EventListSections.FeaturedLinks:
                    // the section loads its own data - see Directives/SectionFeaturedLinks.js
                    SectionRegistry.load(section.id, vm.EventID, vm.lang).catch(function (response) {
                        console.log("GetFeaturedLinks error: ", response && response.data)
                    });
                    showContent(section);
                    handleReceivedData(section.id);
                    break;

                case EventListSections.Testimonials:
                    // the section loads its own data - see Directives/SectionTestimonials.js
                    SectionRegistry.load(section.id, vm.EventID, vm.lang).then(function () {
                        handleReceivedData(section.id);
                    }).catch(function (response) {
                        console.log("GetTestimonials error: ", response && response.data)
                    })
                    showContent(section);
                    break;

                case EventListSections.FeaturedStories:
                    // the section loads its own data - see Directives/SectionFeaturedStories.js
                    SectionRegistry.load(section.id, vm.EventID, vm.lang).catch(function (response) {
                        console.log("GetFeaturedStories error: ", response && response.data)
                    })
                    showContent(section);
                    handleReceivedData(section.id);
                    break;

                case EventListSections.FeaturedStats:
                    // the section loads its own data - see Directives/SectionFeaturedStats.js
                    SectionRegistry.load(section.id, vm.EventID, vm.lang).then(function () {
                        handleReceivedData(section.id);
                    }).catch(function (response) {
                        console.log("GetFeaturedStats error: ", response && response.data)
                    })
                    showContent(section);
                    break;

                case EventListSections.SocialLinks:
                    // the section loads its own data - see Directives/SectionSocialLinks.js
                    SectionRegistry.load(section.id, vm.EventID, vm.lang).then(function () {
                        handleReceivedData(section.id);
                    }).catch(function (response) {
                        console.log("Get SocialLinks error: ", response && response.data)
                    })
                    showContent(section);
                    break;

                case EventListSections.FAQ:
                    // the section loads its own data - see Directives/SectionFaq.js
                    SectionRegistry.load(section.id, vm.EventID, vm.lang).then(function () {
                        handleReceivedData(section.id);
                    }).catch(function (response) {
                        console.log("Get FAQ error: ", response && response.data)
                    })
                    showContent(section);
                    break;

                case EventListSections.VenueMap:
                    // the section loads its own maps - see Directives/SectionVenueMap.js
                    SectionRegistry.load(section.id, vm.EventID, vm.lang).then(function () {
                        handleReceivedData(section.id);
                    }).catch(function (response) {
                        console.log("Get venueMaps error: ", response && response.data)
                    })
                    showContent(section);
                    break;

                case EventListSections.CountryMap:
                    // the section loads its own data - see Directives/SectionCountryMap.js
                    SectionRegistry.load(section.id, vm.EventID, vm.lang).then(function () {
                        handleReceivedData(section.id);
                    }).catch(function (response) {
                        console.log("Get users countries error: ", response && response.data)
                    })
                    showContent(section);
                    break;

                case EventListSections.Description:
                case EventListSections.Abstract:
                case EventListSections.Networking:
                case EventListSections.SliderWelcome:
                case EventListSections.Header:
                    handleReceivedData(section.id);
                    showContent(section);
                    break;

                default:
                    handleReceivedData(section.id);
                    showContent(section);
            }
        }

        function showContent(section) {
            if (vm.allSections.length > 0 && !section.loadedContent) {
                const body = document.querySelector('#' + section.id + ' .section-body');
                if (body) body.style.display = '';
                vm.allSections[section.order].loadedContent = true;
                section.loadedContent = true;
            }
        }

        function initProperties(pageID, eventID, code, date, lang, timeZone) {
            if (pageID != undefined)
                currentPageID = pageID;

            if (eventID != undefined)
                vm.EventID = parseInt(eventID);

            if (code != undefined)
                vm.MailModel.Code = code;

            vm.offset = timeZone
            if (date != undefined) {
                vm.date = date;
            }

            if (lang != undefined)
                vm.lang = lang;

            if (vm.lang == 13 || vm.lang == 'he')
                msg = Constants.Texts.ShareLinkTxtHe + vm.pageUrl;

            // share message as a query string value for the email / WhatsApp share links
            vm.shareMsgEncoded = encodeURIComponent(msg);
        }

        function isBGColorlight(elem) {
            const bgcolor = window.getComputedStyle(elem).backgroundColor;

            if (bgcolor == 'rgb(255, 255, 255)' || bgcolor == 'rgba(0, 0, 0, 0)')
                return true;

            return false;
        }

        vm.isRTL = function (text) {
            return isRTL(text);
        }

        //#endregion functions

        function scrollToSection() {
            vm.allowScroll = true;
            loadIfNeeded();
        }

        function handleReceivedData(sectionID) {
            SpinnerService.Hide(sectionID);

            if (sectionID.indexOf('Speakers') == -1)
                $timeout(function () {
                    sendDocHeightMsg();
                }, 500);
        }


        if (isEmbed) {
            var exModal = document.getElementById('exhibitorModal');
            if (exModal) {
                exModal.addEventListener('show.bs.modal', function (e) {
                    this.style.top = (this.dataset.y || 0) + 'px';
                    });
            }
        }

        function getUrlParam(url, parameter) {
            let urlparameter = '';
            if (url.indexOf(parameter) > -1)
                urlparameter = getUrlVars(url)[parameter];

            return urlparameter;
        }

        function getUrlVars(url) {
            const vars = {};
            url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
                vars[key] = value;
            });

            return vars;
        }

        /**
         * add webID to url if not eventact subdomain  
         * @param {string} url
         * @returns
         */
        function ensureWebID(url) {
            if (window.location.href.indexOf('events.eventact.com') > -1)
                return url;

            url = ensureParam(url, 'webid', webID);
            return url;
        }

        /**
         * add parameter to link if not exists
         * @param {string} url
         * @param {string} param
         * @param {string} value
         * @returns
         */
        function ensureParam(url, param, value) {
            if (!url)
                return url;

            const separator = (url.indexOf('?') > -1) ? "&" : "?";
            const urlParam = getUrlParam(url, param);
            if (!urlParam)
                url = url + separator + param + "=" + encodeURIComponent(value);

            return url;
        }

        /**
         * append known UTM params to link if website was redirected with campaign
         * it will also add webID to url 
         * @param {string} linkUrl
         * @param {string[]} params
         * @returns
         */
        function addAdditionalParams(linkUrl, params) {
            linkUrl = ensureWebID(linkUrl);
            if (!params || params.length == 0)
                return linkUrl;

            for (let i = 0; i < params.length; i++) {
                const utmParam = params[i];
                const param = getCookie('eventlist_' + utmParam);
                if (!param)
                    continue;

                //check if already exists in link
                const urlParam = getUrlParam(linkUrl, params[i]);
                if (!urlParam)
                    linkUrl = linkUrl + "&" + params[i] + "=" + param;
            }

            return linkUrl;
        }

        // if page has utm parameters
        /**
         * Get the visitor's country (by IP) for the speakers country display.
         * The page is output cached so the country can't be rendered into it.
         */
        function loadUserCountry() {
            ApiFactory.GetUserCountry().then(function (res) {
                userCountry = res.data.countryId || 0;
            });
        }

        function setClientCookie() {
            const vars = {};
            window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
                vars[key] = value;
            });

            for (let i = 0; i < utmParams.length; i++) {
                const utmParam = utmParams[i];
                if (vars.hasOwnProperty(utmParam))
                    setCookie('eventlist_' + utmParam, vars[utmParam], null); // null = cookie duration = session
            }
        }

        /**
         * close the side menu
         */
        function closeMenu() {
            if (bsOffcanvas)
                bsOffcanvas.hide();
        }

        /**
         * is any eventact url
         * @param {string} link
         * @returns
         */
        function isReglink(link) {
            if (!link)
                return false;

            return link.indexOf('eventact.com') > -1;
        }

        window.addEventListener('resize', sendDocHeightMsg);
    };

})();
